import { ArenaGuidePage } from '@/components/arena-guide-page'

export function GameRulesPage() {
  return <ArenaGuidePage kind="rules" />
}
